/**
 * rondo-web-forms
 *
 * Rondo Web Forms
 *
 * @author Jiri Hybek <jiri@hybek.cz>
 * @license See LICENSE file distributed with this source code.
 */

import React from "react";

import { bem } from "../../../shared/BEM";
import { useFormElement } from "../../../shared/hooks/useFormElement";
import { FormHTMLContent } from "../../../shared/FormModel/elements/FormHTMLContent";
import { applyInlineElementMods } from "./shared";

/**
 * Component props
 */
export interface IFormHTMLContentComponentProps {
	element: FormHTMLContent
}

export function FormHTMLContentComponent(props: IFormHTMLContentComponentProps) {

	const state = useFormElement(props.element);

	const mods = [];

	if (state.config.noPadding) {
		mods.push("no-padding");
	}

	applyInlineElementMods(state.config, mods);

	const stl = bem("form-html-content", null, mods);

	return <div className={stl.str + " rtc"}>{props.element.evalContent()}</div>;

}
